<template>
  <div>
    <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
          <div class="pr-6 pb-8 w-full">
            <label class="form-label">Observación</label>
            <textarea v-model="form.observation" rows="3"
              class="form-input mt-1 w-full"
              :class="form.errors.observation ? 'error' : ''">
            </textarea>
            <div v-if="form.errors.observation" class="form-error">{{ form.errors.observation }}</div>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!supportType.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
            {{ __('Delete') }}
          </button>
          <button v-if="supportType.deleted_at" class="text-orange-600 hover:underline" tabindex="-1" type="button" @click="restore">
            Restaurar
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ __('Update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    supportType: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.supportType.name,
        observation: this.supportType.observation,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('support_types.update', this.supportType.id))
    },
    destroy() {
      if (confirm('¿Estás seguro de que quieres eliminar este tipo de soporte?')) {
        this.$inertia.delete(this.route('support_types.destroy', this.supportType.id))
      }
    },
    restore() {
      if (confirm('¿Estás seguro de que quieres restaurar este tipo de soporte?')) {
        this.$inertia.put(this.route('support_types.restore', this.supportType.id))
      }
    },
  },
}
</script>
